import StudentClassDashboard from "./components/student-class-dashboard";

function MyClass() {
  return (
    <div className="h-full flex flex-col gap-6">
      <div className="h-full">
        <StudentClassDashboard />
      </div>
    </div>
  );
}

export default MyClass;
